module.exports = __webpack_public_path__ + "static/app-shot-n-1-5-5a9fd0879132f83dd7db35512338cd72.png";